import { FIRMFLOWURL } from "../url";
import axios from "axios";
import Cookies from "js-cookie";
import { administrativeError } from "../administrativeError";

const UNKNOWN_OUTCOME = "The deletion result could not be confirmed. It may have completed.";

// Verified TeamController contract: { replacementTeamId, mappings, dryRun }.
export async function deleteTeamDoAll(teamId, body) {
    try {
        const response = await axios.delete(`${FIRMFLOWURL}api/Team/${encodeURIComponent(teamId)}`, {
            headers: { Authorization: Cookies.get("Bearer"), "Content-Type": "application/json" },
            data: body,
            suppressForbiddenToast: true,
            timeout: 30000,
        });
        return {
            ...response,
            success: response.data?.success === true,
            message: response.data?.message || UNKNOWN_OUTCOME,
        };
    } catch (error) {
        // Never retry an ambiguous destructive request.
        const result = administrativeError(error, UNKNOWN_OUTCOME);
        if (result.status === 409) {
            // The verified DTO uses the same 409 for validation and uncertain commit.
            // Preserve its message as text; never infer that the transaction rolled back.
            const message = error.response?.data?.message;
            result.message = typeof message === "string" && message.trim() ? message : UNKNOWN_OUTCOME;
        } else if (!result.status || result.status >= 500) {
            result.message = UNKNOWN_OUTCOME;
        }
        return result;
    }
}
